<template>
  <div>
      <div>
        <div v-if="arrayCodigos.length > 0">
          <TableReutilizableVue
          :title=" ' Códigos del documento '+ObjectSelected.codigo_devolucion"
          :headers="['Código','Libro','Código liquidacion','Combo','Combo Generado','Factura','Documento','Empresa Documento','Estado en Doc']"
          :fieldKeys="['codigo','nombrelibro','pro_codigo','combo','codigo_combo','factura','documento','descripcion_empresa','estadoCodigoDoc']"
          :ifexportar="Number(1)"
          :nombrearchivo="ObjectSelected.codigo_devolucion"
          :tableData="arrayCodigos"
          />
        </div>
      </div>
  </div>
</template>
<script>
  const TableReutilizableVue                = () => import('@/views/pedidos2/pedidos/reportes/components/TableReutilizable.vue')
export default {
  components: {
    TableReutilizableVue,
  },
  data () {
    return {
      arrayCodigos:[],
    }
  },
  props:{
    ObjectSelected:{
      type:Object,
      default:function(){
        return {}
      }
    }
  },
  created(){

  },
  mounted() {
    let me = this
    me.getCodigos()
  },

  methods: {
    async getCodigos(){
      let me = this
      me.arrayCodigos = []
      try {
          const url = `devoluciones?getCodigosDevolucionTodos=1&idDevolucion=${me.ObjectSelected.id}`;
          const response = await me.$http.get(this.$server_url + url);
          me.arrayCodigos = response.data;
      } catch (e) {
          console.error("Error fetching codes:", e);
      }
    }
  }
}
</script>
